// extracted by mini-css-extract-plugin
export default {"root":"SectionShipping_root__GrPy8","sectionHeading":"SectionShipping_sectionHeading__XmnUG p"};